<script lang="ts">
export default {
  name: 'FormAddOrder',
  props: {
    activeItems: { required: true, type: Number },
    id: { required: true, type: Number },
  },
};
</script>

<template>
  <form
    v-if="activeItems"
    data-hs-cf-bound="true"
    class="ml-2"
    method="post"
    name="reorder"
    style="display: inline"
  >
    <input name="ACTION" type="hidden" value="COPY_ORDER" />
    <input name="invoice_ID" type="hidden" :value="id" />
    <input
      alt="Add to cart"
      class="button primary extra-compact"
      name="button_copy_order"
      style="display: inline-block"
      type="submit"
      value="Add to cart"
    />
  </form>
</template>
